import Vue from 'vue'

const bookModule = {
    state: {
        bookList: [],
        currentBook: {},
        categoriesList: []
    },
    mutations: {
        SET_BOOKS (state, newVal) {
            state.bookList = newVal
        },
        SET_CURRENT_BOOK (state, newVal) {
            state.currentBook = newVal
        },
        SET_CATEGORIES (state, newVal) {
            state.categoriesList = newVal
        }
    },
    getters: {
        getBooks (state) {
            return state.bookList
        },
        getBook (state) {
            return state.currentBook
        },
        getCategories (state) {
            return state.categoriesList
        }
    },
    actions: {
        async FETCH_BOOKS (ctx) {
            let result = await Vue.API.AmfRequest(
                'iqistic.Incarnation',
                'getAllBooks'
            )

            ctx.commit('SET_BOOKS', result.data)
        },
        async FETCH_CATEGORIES (ctx) {
            let result = await Vue.API.AmfRequest(
                'frechmann.Book',
                'getCategories'
            )

            ctx.commit('SET_CATEGORIES', result.data)
        },
        async FETCH_BOOK (ctx, id) {
            let result = await Vue.API.AmfRequest(
                'frechmann.Book',
                'getBookData',
                id
            )

            ctx.commit('SET_CURRENT_BOOK', result.data[0])
        },
        async SAVE_BOOKS ({ dispatch, commit }) {
            await dispatch('book/FETCH_BOOKS')
        }
    }
}
export const strict = false
export const state = bookModule.state
export const getters = bookModule.getters
export const mutations = bookModule.mutations
export const actions = bookModule.actions
